var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58874 4.62828C2.72656 4.35576 3.00996 4.16667 3.33325 4.16667H16.6666C16.9899 4.16667 17.2733 4.35577 17.4111 4.6283L9.99994 9.81612L2.58874 4.62828ZM0.833252 5.00849V5V5.00849ZM0.833252 5.00849V15C0.833252 16.3769 1.95635 17.5 3.33325 17.5H16.6666C18.0435 17.5 19.1666 16.3769 19.1666 15V5.01183C19.1667 5.00241 19.1667 4.99298 19.1665 4.98355C19.1576 3.61416 18.038 2.5 16.6666 2.5H3.33325C1.96047 2.5 0.839985 3.61638 0.833282 4.98763M17.4999 6.60056V15C17.4999 15.4564 17.123 15.8333 16.6666 15.8333H3.33325C2.87682 15.8333 2.49992 15.4564 2.49992 15V6.60053L9.52205 11.516C9.80899 11.7169 10.1909 11.7169 10.4778 11.516L17.4999 6.60056Z",
    fill: "#556685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c717415d64aa992e957b47f43b48f24d.svg";
export { ForwardRef as ReactComponent };